import { Link } from "react-router-dom";
import { ReactComponent as PromptIcon } from "../../Asset/promptIcon.svg";
import { useNavigate } from "react-router-dom";
import "./verifyconfirmation.css"
import { useContext } from "react";
import { AuthContext } from "../../Context/AuthContext";


const VerifyConfirmation = () => {
    const navigate = useNavigate()
    const {userType} = useContext(AuthContext)
  return (
    <div className="verify-comfrim-container">
        <div className="content">
      <div className="header">
        <Link to="/">{userType}</Link>
      </div>

      <div className="card">
        <PromptIcon />
        <h3>Successful</h3>
        <p>
        Your email address has been verify successfully. return to log into your account
        </p>
        <button onClick={() => navigate("/ChooseAccount")}>Log in</button>
      </div>
        </div>
      <div className="img"></div>
    </div>
  );
}
 
export default VerifyConfirmation;